module.exports = __webpack_public_path__ + "img/umbrella.a51cea92.svg";